import { useState } from 'react';
import type { KeyboardEvent, SyntheticEvent } from 'react';

import { Loader } from '../Loader';
import { Modal } from '../Modal';

interface ImgCellProps {
  sources?: string[];
}

export function ImgCell({ sources = [] }: ImgCellProps) {
  const [loading, setLoading] = useState(true);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewSource, setPreviewSource] = useState<string | null>(null);

  function onClickPreview(event: SyntheticEvent<HTMLImageElement>) {
    setPreviewLoading(true);
    setPreviewSource(event.currentTarget.src);
  }

  function onModalClose() {
    setPreviewLoading(false);
    setPreviewSource(null);
  }

  function onKeypress(event: KeyboardEvent<HTMLImageElement>) {
    if (event.code !== 'Enter' && event.code !== 'Space') return;
    event.preventDefault();
    onClickPreview(event);
  }

  return (
    <>
      <div className="images">
        {loading && <Loader />}
        {sources.map((src) => (
          <img
            key={src}
            src={src}
            onClick={onClickPreview}
            onKeyDown={onKeypress}
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)}
            style={{ opacity: loading ? 0 : 1 }}
            className="images__item"
            loading="lazy"
            alt=""
            tabIndex={0}
          />
        ))}
      </div>

      <Modal
        isOpen={!!previewSource}
        onClose={onModalClose}
        title={previewSource}
      >
        <div className="images">
          {previewLoading && <Loader />}
          <img
            src={previewSource ?? undefined}
            alt=""
            onLoad={() => setPreviewLoading(false)}
            onError={() => setPreviewLoading(false)}
            style={{ opacity: previewLoading ? 0 : 1 }}
            className={previewLoading ? 'images__item' : ''}
          />
        </div>
      </Modal>
    </>
  );
}
